<div (click)="onClose()"
  [ngStyle]="!isMobile && {'padding.%': 5}"
  class="alert-box">
  <div>
    <div class="header-icon-container">
      <img alt="" class="header-img" loading="lazy"
        role="button" src="assets/scalableVectorGraphics/close.svg" />
      </div>
      <br>
        @if (sessionInitialized$ | async) {
          <p
          class="text-center">{{ "idle.message" | translate }}</p>
        }
        @if ((sessionInitialized$ | async) === false) {
          <p
            class="text-center"
          id="expired-text"> {{ "idle.expired" | translate }}</p>
        }
        <br>
          @if (sessionInitialized$ | async) {
            <button (click)="stay()"
              [ngClass]="{'w-30': !isMobile}"
              class="btn btn-outline-light black-outline" type="button">{{ "idle.stay" | translate }}
            </button>
          }
          <br>
            @if (sessionInitialized$ | async) {
              <button (click)="logout()"
                [ngClass]="{'w-30': !isMobile}"
                class="btn btn-outline-light black-outline" type="button">{{ "idle.logout" | translate }}
              </button>
            }
            @if ((sessionInitialized$ | async) === false) {
              <button (click)="onLogin()"
                [ngClass]="{'w-30': !isMobile}"
                class="btn btn-outline-light black-outline" type="button">{{ "idle.login" | translate }}
              </button>
            }
            <p class="text-center"> {{ message }}</p>
          </div>
        </div>
